import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function StresYonetimiTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['stres-yonetimi-testi']} />;
}
